import { ShieldCheck, Trash2, Download, Mail } from "lucide-react";
import EmailSettings from "@/components/EmailSettings";

export default function AdminPanel({ flagged, vendorStatus, sendingDigest, onAction, onExportNcmec, onSendDigest }) {
  return (
    <section className="border border-[rgba(140,58,52,0.4)] rounded-sm p-6 sm:p-8 mb-14 bg-[rgba(140,58,52,0.06)]" data-testid="admin-panel">
      <div className="flex items-center gap-2 mb-2">
        <ShieldCheck className="w-4 h-4 text-[#8C3A34]" />
        <span className="text-[10px] uppercase tracking-widest text-[#8C3A34] font-mono-brass">Admin · Trust & Safety</span>
      </div>
      <h2 className="font-serif-display text-2xl text-[#F7F3EC] mb-4">Flagged & rejected works</h2>

      {vendorStatus && (
        <div className="mb-6 border border-[rgba(217,180,114,0.15)] rounded-sm p-4 bg-[#0D0C0A]/50" data-testid="vendor-status">
          <div className="text-[10px] uppercase tracking-widest text-[#D9B472] font-mono-brass mb-2">Detection layers</div>
          <ul className="space-y-1">
            {vendorStatus.layers_active.map((l) => (
              <li key={l} className="text-sm font-serif-body flex items-start gap-2">
                <span className={l.includes("NOT WIRED") ? "text-[#8C3A34]" : "text-[#E6B860]"}>{l.includes("NOT WIRED") ? "◌" : "●"}</span>
                <span className={l.includes("NOT WIRED") ? "text-[#A8A095] italic" : "text-[#F7F3EC]"}>{l}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      <div className="flex flex-wrap gap-2 mb-6">
        <button onClick={onExportNcmec} className="btn-ghost-gold px-4 py-2 rounded-sm font-mono-brass text-[10px] uppercase tracking-widest inline-flex items-center gap-2" data-testid="admin-ncmec-export">
          <Download className="w-3.5 h-3.5" /> Export NCMEC incidents (CSV)
        </button>
        <button onClick={onSendDigest} disabled={sendingDigest} className="btn-ghost-gold px-4 py-2 rounded-sm font-mono-brass text-[10px] uppercase tracking-widest inline-flex items-center gap-2 disabled:opacity-50" data-testid="admin-send-digest">
          <Mail className="w-3.5 h-3.5" /> {sendingDigest ? "Sending…" : "Send digest now"}
        </button>
      </div>

      <EmailSettings />

      {!flagged || flagged.works.length === 0 ? (
        <p className="text-sm text-[#A8A095] font-serif-body italic">Nothing awaiting review. The archive is quiet.</p>
      ) : (
        <div className="space-y-3">
          {flagged.works.map((w) => (
            <div key={w.id} className="border border-[rgba(217,180,114,0.15)] rounded-sm p-4" data-testid={`flagged-work-${w.id}`}>
              <div className="flex flex-wrap items-start justify-between gap-3">
                <div className="flex-1 min-w-0">
                  <div className="font-mono-brass text-[10px] uppercase tracking-widest text-[#8C3A34] mb-1">{w.moderation_status} · {w.report_count || 0} report{(w.report_count || 0) === 1 ? "" : "s"}</div>
                  <div className="font-serif-display text-xl text-[#F7F3EC]">{w.title}</div>
                  <div className="text-xs text-[#A8A095] italic">by {w.author_pseudonym}</div>
                  {flagged.reports[w.id]?.length > 0 && (
                    <details className="mt-2 text-sm">
                      <summary className="cursor-pointer text-[10px] uppercase tracking-widest text-[#D9B472] font-mono-brass">View {flagged.reports[w.id].length} report reason(s)</summary>
                      <ul className="mt-2 space-y-1">
                        {flagged.reports[w.id].map((r) => (
                          <li key={r.id} className="text-xs text-[#A8A095] font-serif-body italic border-l border-[#8C3A34] pl-3 py-1">"{r.reason}"</li>
                        ))}
                      </ul>
                    </details>
                  )}
                </div>
                <div className="flex flex-wrap gap-2">
                  <button onClick={() => onAction(w.id, "approve")} className="btn-ghost-gold px-3 py-1.5 rounded-sm font-mono-brass text-[10px] uppercase tracking-widest" data-testid={`admin-approve-${w.id}`}>Approve</button>
                  <button onClick={() => onAction(w.id, "hard_delete")} className="px-3 py-1.5 rounded-sm font-mono-brass text-[10px] uppercase tracking-widest border border-[#8C3A34] text-[#E9B8A8] hover:bg-[rgba(140,58,52,0.2)] transition-colors duration-200 flex items-center gap-1" data-testid={`admin-delete-${w.id}`}>
                    <Trash2 className="w-3 h-3" /> Hard delete
                  </button>
                  <button onClick={() => onAction(w.id, "suspend_author")} className="px-3 py-1.5 rounded-sm font-mono-brass text-[10px] uppercase tracking-widest border border-[#8C3A34] text-[#E9B8A8] hover:bg-[rgba(140,58,52,0.2)] transition-colors duration-200" data-testid={`admin-suspend-${w.id}`}>Suspend author</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
